import { upperFirst } from 'lodash'
import moment from 'moment'

export function formatTimeToString(isoUTC: string, locale: string): string {
  const m = moment.utc(isoUTC).local()
  return m.locale(locale).format('LT')
}

export function formatDateToString(isoUTC: string, locale: string): string {
  const m = moment.utc(isoUTC).local()
  const date = m.locale(locale).format('LL')
  return upperFirst(date)
}

export function formatTimeAgo(isoUTC: string, locale: string): string {
  const m = moment.utc(isoUTC).local()
  return m.locale(locale).fromNow()
}

export function getRoundedHour() {
  const now = moment()
  const minutes = now.minutes()
  const rounded =
    minutes < 30
      ? now.minutes(30).seconds(0).milliseconds(0)
      : now.add(1, 'hour').minutes(0).seconds(0).milliseconds(0)

  return rounded.format('HH:mm')
}
